module.exports = __webpack_public_path__ + "static/media/add other certificate.dfb61df8.svg";